import { Box } from '@mui/material';

const GroupsDisplayContentTab = ({ value, index, children, ...rest }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      data-testid="GroupsDisplayContent.Tab"
      {...rest}
    >
      {value === index && <Box mt={2}>{children}</Box>}
    </div>
  );
};

export default GroupsDisplayContentTab;
